import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

export const CARD_CLASSES =
  'rounded-lg border border-border bg-card p-4 shadow-sm';

type Props = JSX.HTMLAttributes<HTMLDivElement>;

export function Card(props: Props) {
  const [local, rest] = splitProps(props, ['class', 'children']);
  return (
    <div class={classNames(CARD_CLASSES, local.class)} {...rest}>
      {local.children}
    </div>
  );
}
